import { Link as MuiLink, type LinkProps as MuiLinkProps } from '@mui/material';
import NextLink, { type LinkProps as NextLinkProps } from 'next/link';
import { forwardRef } from 'react';

// `LinkProps` is the combination of the MUI `LinkProps` and the Next `LinkProps`
// We wanna use the `href` prop from `next/link` so we omit it from MUI's.
type LinkProps = Omit<MuiLinkProps, 'href'> &
  Omit<NextLinkProps, 'as' | 'passHref' | 'children'>;

/**
 * A convenience component that wraps the MUI `Link` component that provides
 * our look & feel with Next's router `Link`
 *
 * @see https://nextjs.org/docs/api-reference/next/link
 */

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  (muiProps, ref) => {
    return <MuiLink component={NextLink} ref={ref} {...muiProps} />;
  },
);

Link.displayName = 'Link';
